import $ from './../../lib/lQuery';
import Helpers from './../../common/Helpers';
import Localizer from './../../common/Localizer';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import * as ko from 'knockout';

export class ContactPageViewModel {
  constructor(countriesData) {

    if (countriesData.length > 0) {
      countriesData.push({id: 0, name: Localizer.current.get('View.Shop.ContactRequest.SelectCountry')});
      
      if (countriesData.length > 1) {
        countriesData.sort((a, b) => {
          if (!a.Text) return -1;
          if (!b.Text) return 1;
          return a.Text.localeCompare(b.Text);
        });
      }
    }
    
    this.countries = ko.observableArray(countriesData); // Bindable array of countries
    this.selectedCountry = ko.observable(); // Bindable selected country ID
  }

  countryChanged(countryId) {
    
    if (countryId === 0)
        this.selectedCountry(null);
    
    this.selectedCountry(this.countries().find(c => c.id === countryId));
  }
}

export default class ContactPage {
  constructor(router) {
    this.sendContactUrl = router.getPathForRoute('ContactSend');
    this.crPhoneNumber = null;
    this.errorMap = [
      Localizer.current.get('View.Shop.CheckoutWizard.InvalidPhoneNumber'),
      Localizer.current.get('View.Shop.CheckoutWizard.InvalidPhoneCountryCode'),
      Localizer.current.get('View.Shop.CheckoutWizard.PhoneNumberTooShort'),
      Localizer.current.get('View.Shop.CheckoutWizard.PhoneNumberTooLong'),
      Localizer.current.get('View.Shop.CheckoutWizard.InvalidPhoneNumber')
    ];
    this.countriesViewModel = null;
  }

  init() {
    const form = $.i('ContactRequestForm');
    const useCaptcha = form.dataset.useCaptcha === 'True';
    const submitButton = $.i('submit-button');

    let countriesData = [];
    if (form.dataset.countries &&
        form.dataset.countries !== "null" && 
        form.dataset.countries !== "" && 
        form.dataset.countries !== "undefined")
      countriesData = JSON.parse(form.dataset.countries);

    if (countriesData.length > 0) {
      const contactPageViewModel = new ContactPageViewModel(countriesData);
      ko.cleanNode(form);
      ko.applyBindings(contactPageViewModel, form);
    }
    
    $.i('NeedCallBack').on('click', (event) => {
      $.i('crPhone').required = event.target.checked;
      $.i('crPhone').parentNode.toggleClass('required');
    });
    $.i('privacyPolicy').on('change', (event) => {
      submitButton.disabled = !event.target.checked;
    });

    form.on('submit', event => {
      event.preventDefault();
      submitButton.disabled = true;

      const needCallback = $.i('crPhone').required;
      const isPhoneNumberValid = !needCallback || (needCallback && this.crPhoneNumber.isValidNumber());
      if (!form.checkValidity() && !isPhoneNumberValid) {
        shop.notifier.warning(dashBoard.localizer.get('View.Admin.Edit.InvalidForm'));
        submitButton.disabled = false;

        return false;
      }

      const data = Helpers.serializeForm(form);
      data.Phone = this.crPhoneNumber.getNumber();

      $.postJson(`/${this.sendContactUrl}`, data).then(result => {
        if (result.isSuccess) {
          shop.notifier.success(Localizer.current.get('View.Shop.ContactRequest.ThankYou'));

          setTimeout(() => {
            window.history.back();
            shop.hideAskForPriceModal();
          }, 2000);
        } else {
          shop.notifier.error(Localizer.current.get('View.Admin.Edit.InvalidForm'));
          submitButton.disabled = false;
          grecaptcha.reset();
        }
        $.i('NeedCallBack').checked = false;
        $.i('privacyPolicy').checked = false;
      }).catch(e => {
        shop.notifier.error(Localizer.current.get('View.Shop.ContactRequest.InvalidRecaptchaVerification'));
        grecaptcha.reset();
      });
    });

    if (useCaptcha) { //exists, but not rendered yet
      if (typeof grecaptcha === 'undefined') {
        const script = document.createElement('script');
        script.setAttribute('src', form.dataset.captchaUrl);
        document.body.appendChild(script);
      } else {
        try {
          grecaptcha.render('recaptcha');
        } catch (e) { }
      }
    }

    const parameters = $.i('app-parameters').dataset;
    const currentCountryCode = parameters.currentCountryCode.toLowerCase();
    const supportedCountries = parameters.supportedCountries;

    this.crPhoneNumber = this.initTelInput('crPhone', currentCountryCode, supportedCountries);
  }

  reset = (errorMsg) => {
    $.i('crPhone').classList.remove('error');
    if (errorMsg) {
      errorMsg.innerHTML = '';
      errorMsg.classList.add('hide');
    }
  };

  initTelInput(selector, currentCountryCode, supportedCountries) {
    const phoneNumberInput = $.i(selector);
    const iti = intlTelInput(phoneNumberInput, {
      initialCountry: currentCountryCode,
      autoPlaceholder: 'aggressive',
      onlyCountries: JSON.parse(supportedCountries),
      utilsScript:
        'https://cdn.jsdelivr.net/npm/intl-tel-input@24.3.6/build/js/utils.js',
    });

    const errorMsg = $.i(`errorMsg`);
    const eventList = ['keyup', 'blur', 'change'];

    eventList.forEach((event) => {
      phoneNumberInput.addEventListener(event, () => {
        if (errorMsg) {
          this.reset(errorMsg, phoneNumberInput);
          if (phoneNumberInput.value.trim() && phoneNumberInput.value !== '') {
            if (!iti.isValidNumberPrecise()) {
              phoneNumberInput.classList.add('error');
              const errorCode = iti.getValidationError();
              errorMsg.innerHTML = this.errorMap[errorCode];
              errorMsg.classList.remove('hide');
            }
          }
        }
      });
    });
    
    if (errorMsg) {
      phoneNumberInput.addEventListener('change', this.reset(errorMsg, phoneNumberInput));
      phoneNumberInput.addEventListener('keyup', this.reset(errorMsg, phoneNumberInput));
    }
    return iti;
  }
}